import { defineStore } from 'pinia';
import { useStoreManagers } from './managers';
import type { INotificationPersonal } from '~/types/notifications';

export const useStoreNotificationsPersonal = defineStore('notificationsPersonal', {
  state: () => ({
    notificationsPersonal: [] as INotificationPersonal[],
  }),

  actions: {
    async loadNotificationsPersonal() {
      const { data } = (await $fetch('/cms-api/notifications-personals', { method: 'get' })) as any;

      const notificationsWithManagerData = data.map((n: any) => {
        const manager = useStoreManagers().managers.find((m) => m.id === n.managerId);

        return { ...n, manager };
      });

      this.notificationsPersonal = notificationsWithManagerData;
    },

    clearStore() {
      this.$reset();
    },
  },
});
